import { render, staticRenderFns } from "./VInventoryItemClearFaultModal.vue?vue&type=template&id=5a0fb7c6"
import script from "./VInventoryItemClearFaultModal.vue?vue&type=script&lang=js"
export * from "./VInventoryItemClearFaultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports